
    import styled from 'styled-components';

    export const Container = styled.div`
        display: flex;
        position: relative;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        background: ${({theme}) => theme.gray11};
        padding: 10px 10px;
        width: 100%;
        height: auto;
        flex: 1 1 auto;
    `;
    
    export const Content = styled.div`
        display: flex;
        flex-direction: column;
        margin: 0;
        
        &:after
        {
            content: "Advertisement";
            text-transform: uppercase;
            color: ${ ({theme}) => theme.gray7 };
            letter-spacing: 0.025em;
            font-size: ${ 10 / 16 }rem;
            font-weight: 400;
            align-self: flex-end;
            padding: 0;
            margin: 0;
        }
    `;